import * as React from "react";
import {useState} from "react";
import styled from "styled-components";
import {Link, Trans} from "gatsby-plugin-react-i18next";
import {GatsbyImage, StaticImage} from "gatsby-plugin-image";
import {graphql, useStaticQuery} from "gatsby";

const Nav = styled.nav`
  padding: 0 20px;
  min-height: 9vh;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
`;

const Logo = styled.h1`
  font-size: 18px;
  color: white;
`;

const Menu = styled.ul`
  list-style: none;
  display: flex;

  li:nth-child(2) {
    margin: 0px 20px;
  }

  @media (max-width: 1050px) {
    display: none;
  }
`;

const Item = styled.li`
  margin: 20px;
`;

const LinkA = styled.a`
  color: white;
  text-decoration: none;
  font-size: 16px;

  :hover {
    text-decoration: underline;
  }
`;

const NavIcon = styled.button`
  background: none;

  cursor: pointer;
  border: none;
  outline: none;

  @media (min-width: 1050px) {
    display: none;
  }
`;

const Line = styled.span`
  display: block;
  border-radius: 50px;
  width: 25px;
  height: 3px;
  margin: 5px;
  background-color: black;
  transition: width 0.4s ease-in-out;
  z-index: 1000;

  :nth-child(2) {
    width: ${(props) => (props.open ? "40%" : "70%")};
  }
`;

const Overlay = styled.div`
  position: absolute;
  height: ${(props) => (props.open ? "30vh" : 0)};
  width: 100vw;
  background: #1c2022;
  transition: height 0.4s ease-in-out;
  z-index: 1000;

  @media (min-width: 1050px) {
    display: none;
  }
`;

const OverlayMenu = styled.ul`
  list-style: none;
  position: absolute;
  left: 10%;
  top: 10%;

  li {
    opacity: ${(props) => (props.open ? 1 : 0)};
    font-size: 25px;
    margin: 0px 0px;
    transition: opacity 0.4s ease-in-out;
  }

  li:nth-child(2) {
    margin: 0px 0px;
  }
`;

const MobileMenu = () => {
	const [toggle, toggleNav] = useState(false);
	const {footer, logo, social} = useStaticQuery(
		graphql`
			query {
				logo: file(relativePath: {eq: "logo.png"}) {
					childImageSharp {
						gatsbyImageData(layout: FIXED, height: 50)
					}
				}
			}
		`
	);
	return (
		<>
			<Nav>
				<Logo>
					<Link to="/">
						<GatsbyImage
							alt="Logo"
							image={logo.childImageSharp.gatsbyImageData}
							className="w-40"
						/>
					</Link>
				</Logo>
				<NavIcon onClick={() => toggleNav(!toggle)}>
					<Line open={toggle}/>
					<Line open={toggle}/>
					<Line open={toggle}/>
				</NavIcon>
			</Nav>
			<Overlay open={toggle} className={`${toggle ? 'block transition-all' : 'hidden'}`}>
				<OverlayMenu open={toggle} className={`${toggle ? 'block transition-all' : 'hidden'}`}>
					<Item>
						<LinkA>
							<Link to="/">
								<Trans>Home</Trans>
							</Link>
						</LinkA>
					</Item>
					<Item>
						<LinkA>
							<Link to="/posts">
								<Trans>Posts</Trans>
							</Link>
						</LinkA>
					</Item>
					<Item>
						<LinkA>
							<Link to="/contact-us">
								<Trans>Contact Us</Trans>
							</Link>
						</LinkA>
					</Item>
				</OverlayMenu>
			</Overlay>
		</>
	);
};

export default MobileMenu;
